import { AttributesMixin, define, Model } from "@type-r/models";
import { CreditNote } from "./creditNote";
import { restfulIO } from "./endpoint";

export interface ManualCreditNote extends AttributesMixin<typeof ManualCreditNote> { }
@define
export class ManualCreditNote extends Model {
  static endpoint = restfulIO('api/v1/ingest/creditNotes');

  static attributes = {
    id: String,
    status: String,
    ...CreditNote.attributes
  }
}
